export const APP_NAME = 'News Revenue Engine';

// Errors
export const GENERIC_ERROR = 'We encountered an issue and have been notified. Please try again.';
export const GENERIC_ERROR_WITH_SUPPORT_INFO =
  'We encountered an issue and have been notified. Please try again. If this issue persists, please contact revenginesupport@fundjournalism.org.';

// Other values
export const NO_VALUE = '---';
export const GOOGLE_FONT_MODS = 'ital,wght@0,100;0,300;0,400;0,700;1,400';

// Settings
export const ORGANIZATION_SUCCESS_TEXT = 'Successfully saved details!';

// Account
export const FORGOT_PASSWORD_SUCCESS_TEXT = 'Success. If your email is registered, an email will be sent to it.';
export const RESET_PASSWORD_SUCCESS_TEXT = 'Your password has been successfully reset.';
// Ref: https://github.com/newsrevenuehub/rev-engine/pull/621
export const RESEND_VERIFICATION_SUCCESS_TEXT = 'Verification email has been successfully sent.';
export const VERIFIED_RESULTS_ACCEPTED_VALUES = ['failed', 'expired', 'inactive', 'unknown'];
export const VERIFIED_HELP_EMAIL = `revenginesupport@fundjournalism.org`;
export const SIGN_UP_GENERIC_ERROR_TEXT = 'Account not created. Please try again!';

//Stripe Connect
export const CONNECT_STRIPE_COOKIE_NAME = 'hideConnectStripeModal';
export const CONNECT_STRIPE_FAQ_LINK =
  'https://news-revenue-hub.atlassian.net/servicedesk/customer/portal/11/article/2217443333';

// Page Editor
export const DELETE_LIVE_PAGE_CONFIRM_TEXT =
  'This page is currently published, and deleting it means users will no longer be able to acccess it. Are you sure you want to proceed?';
